import { render, staticRenderFns } from "./newSwiper.vue?vue&type=template&id=6a88b9e1&scoped=true"
import script from "./newSwiper.vue?vue&type=script&lang=js"
export * from "./newSwiper.vue?vue&type=script&lang=js"
import style0 from "./newSwiper.vue?vue&type=style&index=0&id=6a88b9e1&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a88b9e1",
  null
  
)

export default component.exports